/**
 * Display-only translation keys for the category / legend names the dashboard data carries in English.
 * Logic (tracking, hover matching, filter values, css classes) keeps using the raw name; a name without
 * an entry here is rendered as received.
 */
export const DASHBOARD_LABEL_KEYS: Readonly<Record<string, string>> = {
  // Inspection & compliance categories
  'Safety': 'maintenanceDashboard.inspection.categories.safety',
  'Environmental': 'maintenanceDashboard.inspection.categories.environmental',
  'Regulatory': 'maintenanceDashboard.inspection.categories.regulatory',
  'Quality': 'maintenanceDashboard.inspection.categories.quality',

  // Inspection & compliance ratings
  'Good': 'maintenanceDashboard.inspection.good',
  'Near Standard': 'maintenanceDashboard.inspection.nearStandard',
  'Bad': 'maintenanceDashboard.inspection.bad',

  // Parts & inventory stock levels
  'In Stock': 'maintenanceDashboard.partsInventory.inStock',
  'Low Stock': 'maintenanceDashboard.partsInventory.lowStock',
  'Out of Stock': 'maintenanceDashboard.partsInventory.outOfStock'
};